/**
 * Campaign Onboarding - Step names and step configuration
 */
(function (global) {
  "use strict";

  var POLL_INTERVAL = 2000; // 2 seconds
  var MAX_POLL_ATTEMPTS = 600; // 20 minutes max for run_all

  var STEP_NAMES = {
    create_demo: "Setting up onboarding",
    fetch_operations: "Finding campaigns to import",
    initiate: "Loading campaign details",
    start_sync: "Starting data sync",
    check_payload: "Waiting for data",
    create_campaign: "Creating campaign",
    import_accounts: "Importing bank accounts",
    import_transactions: "Importing transactions",
    complete_onboarding: "Finalizing",
    confirm_sync: "Confirm sync",
    fetch_confirm_payload: "Fetch confirm payload",
  };

  function formatDateDisplay(dateString) {
    if (!dateString) return "-";
    var date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  var STEPS = {
    "create-demo": {
      url: null,
      method: "POST",
      existingAlertId: "existing-operation-alert",
      getBody: function () {
        var checked = document.querySelector(
          'input[name="scenario_id"]:checked',
        );
        return { scenario_id: checked ? checked.value : "0" };
      },
      onSuccess: function (data, ctx) {
        var d = data.data || data;
        ctx.setField("operation-id", d.operation_id);
        ctx.setField("customer-id", d.customer_id);
        ctx.enableButton("fetch-operations-btn");
        ctx.enableButton("initiate-btn");
      },
    },
    initiate: {
      url: null,
      method: "POST",
      onSuccess: function (data, ctx) {
        var d = data.data || data;
        ctx.setField("nf-customer-id", d.nf_customer_id);
        ctx.setField("nf-customer-name", d.customer_name || "-");
        ctx.setField("nf-customer-contact", d.customer_contact || "-");
        ctx.setField("nf-customer-email", d.customer_email || "-");
        ctx.setField("nf-customer-phone", d.customer_phone || "-");
        ctx.setField("nf-campaign-id", d.nf_campaign_id);
        ctx.setField("nf-campaign-name", d.campaign_name || "-");
        ctx.setField("nf-campaign-reference", d.campaign_reference || "-");
        ctx.setField("nf-filer-id", d.filer_id || "-");
        ctx.setField("nf-start-date", formatDateDisplay(d.start_date));
        ctx.setField("nf-end-date", formatDateDisplay(d.end_date));
        ctx.enableButton("start-sync-btn");
        ctx.enableButton("create-campaign-btn");
      },
    },
    "start-sync": {
      url: null,
      method: "POST",
      existingAlertId: "existing-sync-alert",
      getBody: function () {
        var dateFromEl = document.getElementById("start-sync-date-from");
        var dateToEl = document.getElementById("start-sync-date-to");
        var body = {};
        if (dateFromEl && dateFromEl.value) body.date_from = dateFromEl.value;
        if (dateToEl && dateToEl.value) body.date_to = dateToEl.value;
        return body;
      },
      onSuccess: function (data, ctx) {
        var d = data.data || data;
        ctx.setField("sync-operation-id", d.operation_id);
        ctx.setField("sync-callback-url", d.callback_url);
        ctx.enableButton("check-payload-btn");
      },
    },
    "check-payload": {
      url: null,
      method: "GET",
      onSuccess: function (data, ctx) {
        if (data.ready) {
          ctx.showElement("check-payload-success");
          ctx.hideElement("check-payload-pending");
          ctx.setField("activity-csv-path", data.activity_csv_path);
          ctx.setField(
            "activity-detail-csv-path",
            data.activity_detail_csv_path || "(not included)",
          );
          ctx.setField(
            "bank-accounts-csv-path",
            data.bank_accounts_csv_path || "(not included)",
          );
          ctx.setField(
            "parameters-json-path",
            data.parameters_json_path || "(not included)",
          );
          if (
            document.getElementById("existing-campaign-created-alert") ||
            !document
              .getElementById("create-campaign-success")
              ?.classList.contains("hidden")
          ) {
            ctx.enableButton("import-accounts-btn");
            ctx.enableButton("import-transactions-btn");
          }
        } else {
          ctx.hideElement("check-payload-success");
          ctx.showElement("check-payload-pending");
        }
      },
    },
    "create-campaign": {
      url: null,
      method: "POST",
      async: true,
      existingAlertId: "existing-campaign-created-alert",
      processingStatus: "campaign_creating",
      completedStatus: "campaign_created",
      failedStatus: "campaign_creation_failed",
      onAsyncComplete: function (status, ctx) {
        ctx.setField(
          "create-campaign-message",
          "Campaign created successfully.",
        );
        ctx.setField("created-campaign-id", status.campaign_id);
        var viewLink = document.getElementById("view-campaign-link");
        if (viewLink && status.campaign_id) {
          viewLink.href = "/campaigns/" + status.campaign_id;
        }
        if (
          !document
            .getElementById("check-payload-success")
            ?.classList.contains("hidden")
        ) {
          ctx.enableButton("import-accounts-btn");
          ctx.enableButton("import-transactions-btn");
        }
      },
    },
    "import-accounts": {
      url: null,
      method: "POST",
      async: true,
      existingAlertId: "existing-accounts-imported-alert",
      processingStatus: "accounts_importing",
      completedStatus: "accounts_imported",
      failedStatus: "accounts_import_failed",
      onAsyncComplete: function (status, ctx) {
        ctx.setField(
          "import-accounts-message",
          "Accounts imported successfully.",
        );
        ctx.enableButton("import-transactions-btn");
      },
    },
    "import-transactions": {
      url: null,
      method: "POST",
      async: true,
      existingAlertId: "existing-transactions-imported-alert",
      processingStatus: "transactions_importing",
      completedStatus: "transactions_imported",
      failedStatus: "transactions_import_failed",
      onAsyncComplete: function (status, ctx) {
        ctx.setField(
          "import-transactions-message",
          "Transactions imported successfully.",
        );
        ctx.enableButton("complete-onboarding-btn");
      },
    },
    "complete-onboarding": {
      url: null,
      method: "POST",
      async: true,
      existingAlertId: "existing-onboarding-completed-alert",
      processingStatus: "completing",
      completedStatus: "completed",
      failedStatus: "completion_failed",
      onAsyncComplete: function (status, ctx) {
        ctx.setField(
          "complete-onboarding-message",
          "Onboarding completed successfully.",
        );
        var goLink = document.getElementById("go-to-campaign-link");
        if (goLink && status.campaign_id) {
          goLink.href = "/campaigns/" + status.campaign_id;
        }
      },
    },
    "confirm-sync": {
      url: null,
      method: "POST",
      onSuccess: function (data, ctx) {
        var d = data.data || data;
        ctx.setField("confirm-sync-operation-id", d.operation_id);
        ctx.setField("confirm-sync-callback-url", d.callback_url);
        ctx.setField(
          "confirm-sync-id",
          d.confirm_id != null ? d.confirm_id : "-",
        );
        ctx.setField(
          "confirm-sync-status",
          d.confirm_status != null ? String(d.confirm_status) : "-",
        );
        ctx.enableButton("fetch-confirm-payload-btn");
        if (d.operation_id && document.body.dataset) {
          document.body.dataset.operationId = d.operation_id;
        }
      },
    },
    "fetch-confirm-payload": {
      url: null,
      method: "GET",
      onSuccess: function (data, ctx) {
        var d = data.data || data;
        ctx.setField("confirm-activity-csv-path", d.activity_csv_path || "-");
        ctx.setField(
          "confirm-activity-detail-csv-path",
          d.activity_detail_csv_path || "(not included)",
        );
        ctx.setField(
          "confirm-bank-accounts-csv-path",
          d.bank_accounts_csv_path || "(not included)",
        );
        ctx.setField(
          "confirm-parameters-json-path",
          d.parameters_json_path || "(not included)",
        );
      },
    },
  };

  global.CampaignOnboarding = global.CampaignOnboarding || {};
  global.CampaignOnboarding.POLL_INTERVAL = POLL_INTERVAL;
  global.CampaignOnboarding.MAX_POLL_ATTEMPTS = MAX_POLL_ATTEMPTS;
  global.CampaignOnboarding.STEP_NAMES = STEP_NAMES;
  global.CampaignOnboarding.STEPS = STEPS;
})(typeof window !== "undefined" ? window : this);
